import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { observer } from 'mobx-react-lite';
import { Pressable, StyleSheet, View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { transformGoogleImageUrl } from 'src/helpers/image.helper';
import { brand, neutrals } from 'src/theme/colors';
import { Image } from 'expo-image';
import { EDITOR_BASE_URL } from 'src/app/settings';
import { AmpMaskView } from '@photosi/rn-components/amp-mask-view/AmpMaskView.web';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

type BannerLoggedUser = {
  profilePic: string;
  email: string;
  handleLogout: () => void;
};

export const BannerLoggedUser = observer(({ profilePic, email, handleLogout }: BannerLoggedUser) => {
  const { i18n } = useStore();
  const { isDesktop } = useResponsiveScreen();

  return (
    <View style={[styleBanner.banner, !isDesktop && styleBanner.bannerMobile]}>
      <View style={styleBanner.userPhoto}>
        <Image
          source={{ uri: transformGoogleImageUrl(profilePic, EDITOR_BASE_URL) }}
          style={{ width: '100%', height: '100%', borderRadius: 100 }}
        />
      </View>
      <AmpMaskView mask="amp-mask" style={[styleBanner.textWrapper, !isDesktop && styleBanner.textWrapperMobile]}>
        <TextLato style={styleBanner.text}>{i18n.t('modal-picker-google-photo:logged-with')}</TextLato>
        <TextLato style={[styleBanner.text, { fontWeight: 700 }]}>{email}</TextLato>
      </AmpMaskView>
      <View>
        <Pressable style={styleBanner.ctaLink} onPress={handleLogout}>
          <TextLato style={styleBanner.ctaLinkText}>{i18n.t('modal-picker-google-photo:logout')}</TextLato>
        </Pressable>
      </View>
    </View>
  );
});

const styleBanner = StyleSheet.create({
  banner: {
    borderRadius: 16,
    paddingVertical: 8,
    paddingHorizontal: 16,
    gap: 12,
    backgroundColor: neutrals.white,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    height: 58,
    minWidth: 327,
    width: '100%',
  },
  bannerMobile: {},
  userPhoto: {
    width: 40,
    height: 40,
    borderRadius: 40,
    backgroundColor: neutrals.neutralGrays.snow,
  },
  textWrapper: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0,
  },
  textWrapperMobile: {},
  text: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.smoke,
  },
  ctaLink: {
    borderBottomWidth: 1,
    borderColor: brand.main.water,
  },
  ctaLinkText: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: brand.main.water,
  },
});
